import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

import { HttpService } from "@atenea-cms";
import { HomeSlider } from "./home-slider.model";

@Injectable()
export class HomeSliderService {
  private rootUrl: string = "";

  constructor(private http: HttpService) {
    this.rootUrl = "home-slider";
  }

  getOne() {
    return this.http.get(`/${this.rootUrl}/sliders`).map(this.http.getJsonData);
  }

  save(item: HomeSlider): Observable<Response> {
    return this.http.put(`/${this.rootUrl}`, item).map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/home-slider.service.ts